// @vendors
import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

// @context
import { useAuth } from '../context/AuthContext';

interface PendingVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PendingVerificationModal: React.FC<PendingVerificationModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
      toast.success('Sesión cerrada correctamente.');
      navigate('/');
      onClose();
      localStorage.clear();
    } catch (error) {
      toast.error('Error al cerrar sesión.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-xervix-bg-secondary dark:bg-xervix-bg-secondary-dark  rounded-lg px-8 pt-8 pb-4 max-w-md w-full">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-xervix-text-primary dark:text-xervix-text-primary-dark">
            Cuenta en verificación
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="mb-6 text-center">
          <div className="flex flex-col items-center justify-center py-4">
            <div className="bg-yellow-100 dark:bg-yellow-900 rounded-full p-3 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">
              Tu cuenta está en proceso de verificación
            </h3>
            <p className="text-gray-600 dark:text-gray-300 mb-12">
              Estamos revisando la información de tu empresa. Este proceso puede tomar hasta 48 horas hábiles.
              Te notificaremos por correo electrónico cuando tu cuenta sea activada.
            </p>

            <div className="flex space-x-4">
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 rounded-md text-gray-800 dark:text-gray-200 transition-colors"
              >
                Cerrar sesión
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-xervix-primary hover:bg-opacity-90 rounded-md text-white transition-colors"
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingVerificationModal;
